import React from 'react';
import ContaTabs from '../ContaTabs'
import AccountMovement from '../AccountMovement';
import AccountListing from '../AccountListing';
import RegistoTable from '../../RegistoModule/Tabs/RegistoTable';
import { withRouter, Link, Route } from 'react-router-dom';
import MovementListing from '../MovemenListing';

class TabsContaDetailsContainer extends React.Component {

    render() {
        return (
            <div className="mt-4">
                {/* <ContaTabs search={ this.props.location.search } date={new Date()} /> */}
                <div className="mt-4">
                    <ContaTabs
                        screen="movements"
                        accountDetails={this.props.accountDetails}
                        entityDetailData={this.props.entityDetailData}
                        search={this.props.location.search}
                    />
                    <ul className="nav nav-tabs tab-container">
                        <li className="nav-item">
                            <Link className={`nav-link p-3 border ${this.props.location.pathname.includes('movements') ? 'active' : 'bg-white text-body'}`} to={{ pathname: 'movements', search: this.props.location.search }}><span className="k-icon k-i-menu"></span>&nbsp;Por Movimento</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link p-3 border ${this.props.location.pathname.includes('registoTable') ? 'active' : 'bg-white text-body'}`} to={{ pathname: 'registoTable', search: this.props.location.search }}><span className="k-icon k-i-menu"></span>&nbsp;Por Registo</Link>
                        </li>
                    </ul>                    
                </div>
            </div>
        )
    }
}

export default TabsContaDetailsContainer;
